// extracted by mini-css-extract-plugin
export default {"headerView":"HeaderBarStyle_headerView__Uj+cL","contents":"HeaderBarStyle_contents__b9LcU","title":"HeaderBarStyle_title__WM6L0","rightView":"HeaderBarStyle_rightView__Wt4pA"};